(function () {
  "use strict";

  /* ── Pre-register product-form to block theme.js competing handler ── */
  try {
    if (typeof customElements !== "undefined" && !customElements.get("product-form")) {
      customElements.define("product-form", class extends HTMLFormElement {
        connectedCallback() {
          // Mirror theme ProductForm: enable the variant <input name="id">
          try { var el = this.elements.namedItem("id"); if (el) el.disabled = false; } catch(e) {}
        }
      }, { extends: "form" });
    }
  } catch (e) { /* Safari: customized built-ins unsupported — capture listener handles ATC */ }

  const MIN_BUSY_MS = 350;
  const MAX_SUPPRESS_MS = 1500;
  const MAX_FORM_SUBMITTING_MS = 12000;
  const CART_ERROR_MESSAGE = "Nu am putut adauga produsul in cos.";
  const GLOBAL_LISTENER_KEY = "__qkAtcFallbackSubmitListenerBound";
  const FORM_SUBMITTING_ATTR = "data-qk-submitting";
  const SOURCE_STOREFRONT = "storefront_cart";
  const LUBE_SELECTED_PROPERTY = "_qk_lube_selected";
  const LUBE_SCOPE_PROPERTY = "_qk_lube_scope";
  const LUBE_RULE_PROPERTY = "_qk_lube_rule";
  const UPSELL_VARIANT_IDS_FIELD = "qk_upsell_variant_ids[]";
  const UPSELL_MATCH_PARENT_QTY_FIELD = "qk_upsell_match_parent_qty";
  const UPSELL_AUTO_DISCOUNT_ENABLED_FIELD = "qk_upsell_auto_discount_enabled";
  const UPSELL_AUTO_DISCOUNT_PERCENT_FIELD = "qk_upsell_auto_discount_percent";
  const UPSELL_MANAGED_PROPERTY = "_qk_upsell_managed";
  const UPSELL_SOURCE_PROPERTY = "_qk_upsell_source";
  const UPSELL_PARENT_VARIANT_PROPERTY = "_qk_upsell_parent_variant";
  const UPSELL_DISCOUNT_PERCENT_PROPERTY = "_qk_upsell_discount_percent";
  const DEFAULT_FEE_RULES = [
    {
      key: "heavy_keyboard",
      feeVariantLegacyId: "47677399138638",
      includeTags: ["heavy keyboard"],
      excludeTags: [],
      suppresses: ["casti_or_keyboards"],
    },
    {
      key: "casti_or_keyboards",
      feeVariantLegacyId: "47677341532494",
      includeTags: ["casti", "keyboards"],
      excludeTags: [],
      suppresses: [],
    },
    {
      key: "mouse_or_cable_not_mouse_cover",
      feeVariantLegacyId: "47677405790542",
      includeTags: ["mouse", "cable"],
      excludeTags: ["mouse-cover"],
      suppresses: [],
    },
  ];

  /** Forms currently being submitted via AJAX — prevents double-click. */
  const inflight = new WeakSet();
  const formSubmittingTimers = new WeakMap();
  var parsedCartRulesCache = null;
  var ownCartAddDepth = 0;
  var _atcInFlight = false;
  var _atcToken = 0;
  var _atcTimer = null;

  /* ── Helpers ─────────────────────────────────────────────────── */

  function isDebugEnabled() {
    return window.__QK_ATC_DEBUG__ === true;
  }

  function debugLog() {
    if (!isDebugEnabled()) return;
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift("[qk-product-form-fallback]");
      console.info.apply(console, args);
    } catch (_error) {
      // ignore logging errors
    }
  }

  function isPaymentButton(el) {
    return el instanceof Element && !!el.closest(".shopify-payment-button, .shopify-cleanslate");
  }

  function isSameOrigin(urlLike) {
    try {
      var url = new URL(String(urlLike || ""), window.location.href);
      return url.origin === window.location.origin;
    } catch (_error) {
      return false;
    }
  }

  function isCartAddUrl(urlLike) {
    try {
      var url = new URL(String(urlLike || ""), window.location.href);
      if (url.origin !== window.location.origin) return false;
      var path = String(url.pathname || "").toLowerCase();
      return /(?:\/|^)cart\/add\/?$/.test(path);
    } catch (_error) {
      return false;
    }
  }

  function isCartAddJsonUrl(urlLike) {
    try {
      var url = new URL(String(urlLike || ""), window.location.href);
      if (url.origin !== window.location.origin) return false;
      var path = String(url.pathname || "").toLowerCase();
      return /(?:\/|^)cart\/add\.js\/?$/.test(path);
    } catch (_error) {
      return false;
    }
  }

  function isCartAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    var actionAttr = form.getAttribute("action");
    var action = actionAttr == null || String(actionAttr).trim() === "" ? form.action : actionAttr;
    return isCartAddUrl(action);
  }

  function hasVariantIdValue(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    try {
      if (form.elements && typeof form.elements.namedItem === "function") {
        var named = form.elements.namedItem("id");
        if (named && typeof named.value !== "undefined") {
          return String(named.value || "").trim() !== "";
        }
      }
    } catch (_error) {
      // fall through
    }
    try {
      var formData = new FormData(form);
      var idValue = formData.get("id");
      return String(idValue == null ? "" : idValue).trim() !== "";
    } catch (_error) {
      return false;
    }
  }

  function isFormSubmitting(form) {
    return form instanceof HTMLFormElement && form.getAttribute(FORM_SUBMITTING_ATTR) === "1";
  }

  function markFormSubmitting(form) {
    if (!(form instanceof HTMLFormElement)) return;
    clearFormSubmitting(form);
    form.setAttribute(FORM_SUBMITTING_ATTR, "1");
    var timer = window.setTimeout(function () {
      if (form.getAttribute(FORM_SUBMITTING_ATTR) === "1") {
        form.removeAttribute(FORM_SUBMITTING_ATTR);
        debugLog("safety clear form submitting flag", form.action);
      }
      formSubmittingTimers.delete(form);
    }, MAX_FORM_SUBMITTING_MS);
    formSubmittingTimers.set(form, timer);
  }

  function clearFormSubmitting(form) {
    if (!(form instanceof HTMLFormElement)) return;
    var timer = formSubmittingTimers.get(form);
    if (timer) {
      clearTimeout(timer);
      formSubmittingTimers.delete(form);
    }
    form.removeAttribute(FORM_SUBMITTING_ATTR);
  }

  function _setAtcInFlight(reason) {
    _atcToken += 1;
    var token = _atcToken;
    _atcInFlight = true;
    if (_atcTimer) clearTimeout(_atcTimer);
    _atcTimer = window.setTimeout(function () {
      if (token !== _atcToken) return;
      _atcInFlight = false;
      _atcTimer = null;
      debugLog("ATC suppress window expired", reason || "unknown");
    }, MAX_SUPPRESS_MS);
    debugLog("ATC suppress window started", reason || "unknown", "token", token);
    return token;
  }

  function _clearAtcInFlight(token, reason) {
    if (token != null && token !== _atcToken) return;
    if (_atcTimer) {
      clearTimeout(_atcTimer);
      _atcTimer = null;
    }
    _atcInFlight = false;
    debugLog("ATC suppress window cleared", reason || "unknown", "token", token);
  }

  function _isCartPageUrl(urlLike) {
    try {
      var url = new URL(String(urlLike || ""), window.location.href);
      if (url.origin !== window.location.origin) return false;

      var normalizedPath = String(url.pathname || "").replace(/\/+$/, "").toLowerCase();
      var rootPath = getRootPath().replace(/\/+$/, "/");
      var cartPath = (rootPath + "cart").replace(/\/+$/, "").toLowerCase();

      return normalizedPath === cartPath;
    } catch (_error) {
      return false;
    }
  }

  function installLocationSuppressor() {
    try {
      var nativeAssign = Location.prototype.assign;
      Location.prototype.assign = function (url) {
        if (_atcInFlight && _isCartPageUrl(url)) {
          debugLog("suppressed location.assign to cart", url);
          return;
        }
        return nativeAssign.call(this, url);
      };
    } catch (_error) {
      debugLog("failed to patch Location.assign");
    }

    try {
      var nativeReplace = Location.prototype.replace;
      Location.prototype.replace = function (url) {
        if (_atcInFlight && _isCartPageUrl(url)) {
          debugLog("suppressed location.replace to cart", url);
          return;
        }
        return nativeReplace.call(this, url);
      };
    } catch (_error) {
      debugLog("failed to patch Location.replace");
    }

    try {
      var hrefDescriptor = Object.getOwnPropertyDescriptor(Location.prototype, "href");
      if (hrefDescriptor && typeof hrefDescriptor.set === "function" && hrefDescriptor.configurable !== false) {
        Object.defineProperty(Location.prototype, "href", {
          configurable: true,
          enumerable: hrefDescriptor.enumerable,
          get: hrefDescriptor.get,
          set: function (value) {
            if (_atcInFlight && _isCartPageUrl(value)) {
              debugLog("suppressed location.href to cart", value);
              return;
            }
            return hrefDescriptor.set.call(this, value);
          },
        });
      }
    } catch (_error) {
      debugLog("failed to patch Location.href");
    }
  }

  function enterOwnCartAdd(reason) {
    ownCartAddDepth += 1;
    debugLog("enter own cart/add", reason || "unknown", "depth", ownCartAddDepth);
  }

  function exitOwnCartAdd(reason) {
    ownCartAddDepth = Math.max(0, ownCartAddDepth - 1);
    debugLog("exit own cart/add", reason || "unknown", "depth", ownCartAddDepth);
  }

  function shouldIntercept(event, form) {
    if (!(form instanceof HTMLFormElement)) {
      debugLog("skip submit intercept: target is not a form");
      return false;
    }
    if (!isCartAddForm(form)) {
      debugLog("skip submit intercept: not cart/add form", form.action);
      return false;
    }
    if (!isSameOrigin(form.action)) {
      debugLog("skip submit intercept: cross-origin form action", form.action);
      return false;
    }
    if (event.submitter && isPaymentButton(event.submitter)) {
      debugLog("skip submit intercept: payment button");
      return false;
    }
    return true;
  }

  function resolveVariantId(form) {
    if (!(form instanceof HTMLFormElement)) return "";
    var namedField = null;
    try {
      if (form.elements && typeof form.elements.namedItem === "function") {
        namedField = form.elements.namedItem("id");
      }
    } catch (_error) {
      namedField = null;
    }
    if (namedField && typeof namedField.value !== "undefined") {
      return String(namedField.value || "").trim();
    }

    var input =
      form.querySelector('input[name="id"]:not([disabled]), select[name="id"]:not([disabled])') ||
      form.querySelector('input[name="id"], select[name="id"]');
    return input ? String(input.value || "").trim() : "";
  }

  function getRootPath() {
    var root =
      typeof window.Shopify?.routes?.root === "string"
        ? window.Shopify.routes.root.trim()
        : "";
    if (root) return root.endsWith("/") ? root : root + "/";
    return "/";
  }

  function cssEscape(value) {
    if (typeof CSS !== "undefined" && typeof CSS.escape === "function") return CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function getSubmitButtons(form) {
    var buttons = [];
    var seen = new Set();
    var formId = String(form.getAttribute("id") || "").trim();

    form.querySelectorAll('button[type="submit"]').forEach(function (b) {
      if (!seen.has(b)) { seen.add(b); buttons.push(b); }
    });

    if (formId) {
      document.querySelectorAll('button[type="submit"][form="' + cssEscape(formId) + '"]').forEach(function (b) {
        if (!seen.has(b)) { seen.add(b); buttons.push(b); }
      });
    }

    return buttons;
  }

  function resolveAssociatedFormControl(form, matcher) {
    if (!(form instanceof HTMLFormElement) || typeof matcher !== "function") {
      return null;
    }

    var controls = form.elements ? Array.from(form.elements) : [];
    for (var i = 0; i < controls.length; i += 1) {
      if (matcher(controls[i])) {
        return controls[i];
      }
    }

    var formId = String(form.id || "").trim();
    if (!formId) {
      return null;
    }

    var escapedId = cssEscape(formId);
    var associatedControls = document.querySelectorAll('[form="' + escapedId + '"]');
    for (var j = 0; j < associatedControls.length; j += 1) {
      if (matcher(associatedControls[j])) {
        return associatedControls[j];
      }
    }

    return null;
  }

  function setButtonsBusy(buttons, busy) {
    buttons.forEach(function (btn) {
      if (!(btn instanceof HTMLButtonElement)) return;
      var loader = btn.querySelector(".button__loader");
      if (busy) {
        btn.setAttribute("disabled", "disabled");
        btn.setAttribute("aria-busy", "true");
        btn.setAttribute("data-qk-atc-loading", "true");
        if (loader instanceof HTMLElement && !loader.hasAttribute("data-qk-loading-label")) {
          loader.setAttribute(
            "data-qk-loading-label",
            (window.themeVariables?.strings?.addToCartButton || "Add to cart") + "...",
          );
        }
      } else {
        btn.removeAttribute("disabled");
        btn.removeAttribute("aria-busy");
        btn.removeAttribute("data-qk-atc-loading");
      }
    });
  }

  function resolveAtcFormFromButton(button) {
    if (!(button instanceof HTMLButtonElement)) return null;
    var directForm = button.form;
    if (isCartAddForm(directForm) && isSameOrigin(directForm.action)) return directForm;

    var closestForm = button.closest("form");
    if (isCartAddForm(closestForm) && isSameOrigin(closestForm.action)) return closestForm;

    var explicitId = String(button.getAttribute("form") || "").trim();
    if (explicitId) {
      var explicitForm = document.getElementById(explicitId);
      if (isCartAddForm(explicitForm) && isSameOrigin(explicitForm.action)) return explicitForm;
    }
    return null;
  }

  function findAnyCartAddForm() {
    var forms = document.forms || [];
    for (var i = 0; i < forms.length; i += 1) {
      if (isCartAddForm(forms[i])) return forms[i];
    }
    return null;
  }

  function parseInteger(value, fallback) {
    var parsed = Number.parseInt(value == null ? "" : String(value), 10);
    return Number.isFinite(parsed) ? parsed : (fallback == null ? 0 : fallback);
  }

  function normalizeLegacyId(value) {
    var normalized = String(value == null ? "" : value).trim();
    if (!normalized) return "";
    if (/^\d+$/.test(normalized)) return normalized;
    var digits = normalized.replace(/[^\d]/g, "");
    return /^\d+$/.test(digits) ? digits : "";
  }

  function toTruthy(value) {
    var normalized = String(value == null ? "" : value).trim().toLowerCase();
    return normalized === "1" || normalized === "true" || normalized === "yes" || normalized === "da" || normalized === "on";
  }

  function parseUpsellDiscountPercent(value) {
    var parsed = parseInteger(value, 0);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return 0;
    }

    return Math.max(0, Math.min(100, parsed));
  }

  function normalizeTagList(tags) {
    return (Array.isArray(tags) ? tags : [])
      .map(function (tag) { return String(tag == null ? "" : tag).trim().toLowerCase(); })
      .filter(Boolean);
  }

  function parseTagList(raw) {
    var source = String(raw == null ? "" : raw).trim().toLowerCase();
    if (!source) return [];
    return normalizeTagList(source.split("||"));
  }

  function readProductTagsFromForm(form) {
    if (!(form instanceof HTMLFormElement)) return [];

    var directRaw = String(form.getAttribute("data-qk-product-tags") || "").trim();
    if (directRaw) {
      return parseTagList(directRaw);
    }

    var marker = form.querySelector("[data-qk-product-tags-value]");
    if (!(marker instanceof HTMLInputElement)) return [];
    return parseTagList(marker.value);
  }

  function readVariantPriceCentsFromForm(form) {
    if (!(form instanceof HTMLFormElement)) return 0;
    var marker = form.querySelector('input[data-qk-variant-price]');
    if (!(marker instanceof HTMLInputElement)) return 0;
    return Math.max(0, parseInteger(marker.value, 0));
  }

  function syncVariantPriceInputFromVariantChange(event) {
    var form = event && event.target instanceof HTMLFormElement ? event.target : null;
    if (!(form instanceof HTMLFormElement)) return;

    var marker = form.querySelector('input[data-qk-variant-price]');
    if (!(marker instanceof HTMLInputElement)) return;

    var variant = event && event.detail && event.detail.variant && typeof event.detail.variant === "object"
      ? event.detail.variant
      : null;
    if (!variant) return;

    var variantPriceCents = Math.max(0, parseInteger(variant.price, 0));
    marker.value = String(variantPriceCents);
  }

  function safeObject(value) {
    return value && typeof value === "object" ? value : {};
  }

  function parseJsonScript(scriptId) {
    var element = document.getElementById(scriptId);
    if (!(element instanceof HTMLScriptElement)) return null;
    var raw = String(element.textContent || "").trim();
    if (!raw || raw === "null") return null;
    try {
      return JSON.parse(raw);
    } catch (_error) {
      return null;
    }
  }

  function parseCartRulesConfig() {
    if (parsedCartRulesCache) return parsedCartRulesCache;

    var source = safeObject(parseJsonScript("qk-cart-rules"));
    var fees = safeObject(source.fees);
    var rawRules = Array.isArray(fees.rules) ? fees.rules : DEFAULT_FEE_RULES;
    var normalizedRules = rawRules.map(function (rule) {
      var value = safeObject(rule);
      return {
        key: String(value.key || "").trim(),
        feeVariantLegacyId: normalizeLegacyId(value.feeVariantLegacyId),
        includeTags: normalizeTagList(Array.isArray(value.includeTags) ? value.includeTags : []),
        excludeTags: normalizeTagList(Array.isArray(value.excludeTags) ? value.excludeTags : []),
        suppresses: (Array.isArray(value.suppresses) ? value.suppresses : [])
          .map(function (entry) { return String(entry == null ? "" : entry).trim(); })
          .filter(Boolean),
      };
    }).filter(function (rule) {
      return Boolean(rule.key && rule.feeVariantLegacyId && rule.includeTags.length);
    });

    parsedCartRulesCache = {
      fees: {
        rules: normalizedRules.length ? normalizedRules : DEFAULT_FEE_RULES,
      },
    };
    return parsedCartRulesCache;
  }

  function resolveMatchedFeeRuleKeys(tags, feeRules) {
    var tagSet = new Set(normalizeTagList(tags));
    var matchedRules = (Array.isArray(feeRules) ? feeRules : []).filter(function (rule) {
      var includesAny = (Array.isArray(rule.includeTags) ? rule.includeTags : []).some(function (tag) {
        return tagSet.has(tag);
      });
      if (!includesAny) return false;
      var excluded = (Array.isArray(rule.excludeTags) ? rule.excludeTags : []).some(function (tag) {
        return tagSet.has(tag);
      });
      return !excluded;
    });

    if (!matchedRules.length) return [];

    var suppressed = new Set();
    matchedRules.forEach(function (rule) {
      (Array.isArray(rule.suppresses) ? rule.suppresses : []).forEach(function (entry) {
        if (entry) suppressed.add(String(entry));
      });
    });

    return matchedRules
      .map(function (rule) { return rule.key; })
      .filter(function (key) { return !suppressed.has(key); });
  }

  function collectPropertiesFromFormData(formData) {
    var properties = {};
    var hasFileProperty = false;
    formData.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(String(key || ""));
      if (!match || !match[1]) return;

      if (value instanceof File) {
        if (value.name) hasFileProperty = true;
        return;
      }

      properties[match[1]] = String(value == null ? "" : value);
    });
    return {
      properties: properties,
      hasFileProperty: hasFileProperty,
    };
  }

  function buildParentAddItem(formData, fallbackVariantId) {
    var idFromData = normalizeLegacyId(formData.get("id"));
    var variantLegacyId = idFromData || normalizeLegacyId(fallbackVariantId);
    if (!variantLegacyId) return null;

    var quantityRaw = parseInteger(formData.get("quantity"), 1);
    var quantity = Math.max(1, quantityRaw);
    var collected = collectPropertiesFromFormData(formData);
    var sellingPlan = String(formData.get("selling_plan") || "").trim();
    var item = {
      id: Number(variantLegacyId),
      quantity: quantity,
    };

    if (Object.keys(collected.properties).length) {
      item.properties = collected.properties;
    }
    if (sellingPlan) {
      item.selling_plan = sellingPlan;
    }

    return {
      item: item,
      hasFileProperty: collected.hasFileProperty,
      parentVariantLegacyId: variantLegacyId,
      parentQuantity: quantity,
      parentProperties: collected.properties,
    };
  }

  function buildFeeAttachmentItems(parentVariantLegacyId, parentQuantity, tags) {
    var rulesConfig = parseCartRulesConfig();
    var rules = Array.isArray(rulesConfig && rulesConfig.fees && rulesConfig.fees.rules)
      ? rulesConfig.fees.rules
      : DEFAULT_FEE_RULES;
    var matchedRuleKeys = resolveMatchedFeeRuleKeys(tags, rules);
    if (!matchedRuleKeys.length) return [];

    return matchedRuleKeys.map(function (ruleKey) {
      var rule = rules.find(function (candidate) {
        return candidate && candidate.key === ruleKey;
      });
      var feeVariantLegacyId = normalizeLegacyId(rule && rule.feeVariantLegacyId);
      if (!feeVariantLegacyId) return null;
      return {
        id: Number(feeVariantLegacyId),
        quantity: Math.max(1, parseInteger(parentQuantity, 1)),
        properties: {
          _qk_fee_managed: "1",
          _qk_fee_rule: String(ruleKey),
          _qk_fee_source: SOURCE_STOREFRONT,
          _qk_fee_source_variant: String(parentVariantLegacyId),
        },
      };
    }).filter(Boolean);
  }

  function buildLubeAttachmentItem(form, parentVariantLegacyId, parentQuantity, parentProperties) {
    if (!(form instanceof HTMLFormElement)) return null;

    var selected = toTruthy(parentProperties && parentProperties[LUBE_SELECTED_PROPERTY]);
    if (!selected) return null;

    var scope = String(parentProperties && parentProperties[LUBE_SCOPE_PROPERTY] || form.getAttribute("data-qk-lube-scope") || "")
      .trim()
      .toLowerCase();
    var ruleKey = String(parentProperties && parentProperties[LUBE_RULE_PROPERTY] || form.getAttribute("data-qk-lube-rule") || "")
      .trim();
    var variantLegacyId = normalizeLegacyId(form.getAttribute("data-qk-lube-variant-id"));

    if (!scope || !ruleKey || !variantLegacyId) {
      return null;
    }

    return {
      id: Number(variantLegacyId),
      quantity: Math.max(1, parseInteger(parentQuantity, 1)),
      properties: {
        _qk_lube_managed: "1",
        _qk_lube_source: SOURCE_STOREFRONT,
        _qk_lube_source_variant: String(parentVariantLegacyId),
        _qk_lube_scope: scope,
        _qk_lube_rule: ruleKey,
      },
    };
  }

  function buildUpsellAttachmentItems(form, formData, parentVariantLegacyId, parentQuantity) {
    if (!(formData instanceof FormData)) {
      return [];
    }

    var selectedVariantIds = formData.getAll(UPSELL_VARIANT_IDS_FIELD);
    if ((!selectedVariantIds || !selectedVariantIds.length) && form instanceof HTMLFormElement) {
      var formId = String(form.id || "").trim();
      if (formId) {
        var escapedFormId = cssEscape(formId);
        selectedVariantIds = Array.from(
          document.querySelectorAll(
            'input[data-qk-upsell-item][form="' + escapedFormId + '"]:checked:not([disabled])',
          ),
        ).map(function (input) {
          return input instanceof HTMLInputElement ? input.value : "";
        });
      }
    }

    if (!selectedVariantIds || !selectedVariantIds.length) {
      return [];
    }

    var shouldMatchParentQuantity = toTruthy(formData.get(UPSELL_MATCH_PARENT_QTY_FIELD));
    if (!shouldMatchParentQuantity && form instanceof HTMLFormElement) {
      var hiddenMatchInput = resolveAssociatedFormControl(form, function (control) {
        return (
          control instanceof HTMLInputElement &&
          control.type === "hidden" &&
          control.name === UPSELL_MATCH_PARENT_QTY_FIELD
        );
      });

      if (hiddenMatchInput instanceof HTMLInputElement) {
        shouldMatchParentQuantity = toTruthy(hiddenMatchInput.value);
      }
    }

    var autoDiscountEnabled = toTruthy(formData.get(UPSELL_AUTO_DISCOUNT_ENABLED_FIELD));
    var autoDiscountPercent = autoDiscountEnabled
      ? parseUpsellDiscountPercent(formData.get(UPSELL_AUTO_DISCOUNT_PERCENT_FIELD))
      : 0;

    if ((!autoDiscountEnabled || autoDiscountPercent <= 0) && form instanceof HTMLFormElement) {
      var hiddenAutoDiscountEnabledInput = resolveAssociatedFormControl(form, function (control) {
        return (
          control instanceof HTMLInputElement &&
          control.type === "hidden" &&
          control.name === UPSELL_AUTO_DISCOUNT_ENABLED_FIELD
        );
      });
      var hiddenAutoDiscountPercentInput = resolveAssociatedFormControl(form, function (control) {
        return (
          control instanceof HTMLInputElement &&
          control.type === "hidden" &&
          control.name === UPSELL_AUTO_DISCOUNT_PERCENT_FIELD
        );
      });

      if (hiddenAutoDiscountEnabledInput instanceof HTMLInputElement) {
        autoDiscountEnabled = toTruthy(hiddenAutoDiscountEnabledInput.value);
      }
      if (hiddenAutoDiscountPercentInput instanceof HTMLInputElement) {
        autoDiscountPercent = autoDiscountEnabled
          ? parseUpsellDiscountPercent(hiddenAutoDiscountPercentInput.value)
          : 0;
      }
    }

    var upsellQuantity = shouldMatchParentQuantity ? Math.max(1, parseInteger(parentQuantity, 1)) : 1;
    var quantityByVariantId = new Map();
    var parentLegacyId = normalizeLegacyId(parentVariantLegacyId);
    var baseUpsellProperties = {};

    baseUpsellProperties[UPSELL_MANAGED_PROPERTY] = "1";
    baseUpsellProperties[UPSELL_SOURCE_PROPERTY] = SOURCE_STOREFRONT;
    if (parentLegacyId) {
      baseUpsellProperties[UPSELL_PARENT_VARIANT_PROPERTY] = String(parentLegacyId);
    }
    if (autoDiscountEnabled && autoDiscountPercent > 0) {
      baseUpsellProperties[UPSELL_DISCOUNT_PERCENT_PROPERTY] = String(autoDiscountPercent);
    }

    selectedVariantIds.forEach(function (value) {
      var upsellVariantLegacyId = normalizeLegacyId(value);
      if (!upsellVariantLegacyId || upsellVariantLegacyId === parentLegacyId) {
        return;
      }

      var currentQuantity = quantityByVariantId.get(upsellVariantLegacyId) || 0;
      quantityByVariantId.set(upsellVariantLegacyId, currentQuantity + upsellQuantity);
    });

    return Array.from(quantityByVariantId.entries()).map(function (entry) {
      return {
        id: Number(entry[0]),
        quantity: Math.max(1, parseInteger(entry[1], 1)),
        properties: Object.assign({}, baseUpsellProperties),
      };
    });
  }

  function stripUpsellFormDataFields(formData) {
    if (!(formData instanceof FormData)) {
      return;
    }

    formData.delete(UPSELL_VARIANT_IDS_FIELD);
    formData.delete(UPSELL_MATCH_PARENT_QTY_FIELD);
    formData.delete(UPSELL_AUTO_DISCOUNT_ENABLED_FIELD);
    formData.delete(UPSELL_AUTO_DISCOUNT_PERCENT_FIELD);
  }

  function resolvePredictiveGiftItems(form, parentQuantity) {
    if (window.__QK_PREDICTIVE_GIFT_PACK__ !== true) {
      return [];
    }

    var api = window.QKCartRules && typeof window.QKCartRules.predictGiftItems === "function"
      ? window.QKCartRules.predictGiftItems
      : null;
    if (!api) {
      return [];
    }

    var variantPriceCents = readVariantPriceCentsFromForm(form);
    if (!variantPriceCents) {
      variantPriceCents = Math.max(0, parseInteger(window.currentProductPrice, 0));
    }
    if (!variantPriceCents) {
      return [];
    }

    var quantity = Math.max(1, parseInteger(parentQuantity, 1));
    try {
      var predictedItems = api({
        addedPriceCents: variantPriceCents,
        addedQuantity: quantity,
      });
      if (!Array.isArray(predictedItems) || !predictedItems.length) {
        return [];
      }

      return predictedItems.map(function (item) {
        var variantLegacyId = normalizeLegacyId(item && item.id);
        if (!variantLegacyId) return null;
        var itemQuantity = Math.max(1, parseInteger(item && item.quantity, 1));
        return {
          id: Number(variantLegacyId),
          quantity: itemQuantity,
          properties: item && item.properties && typeof item.properties === "object" ? item.properties : {},
        };
      }).filter(Boolean);
    } catch (error) {
      debugLog("predictive gift prediction failed", error);
      return [];
    }
  }

  function buildPackedAddPayload(form, formData, options) {
    var rootPath = options && options.rootPath ? options.rootPath : getRootPath();
    var variantId = options && options.variantId ? options.variantId : resolveVariantId(form);
    var sections = Array.isArray(options && options.sections) ? options.sections : [];
    var parentResult = buildParentAddItem(formData, variantId);
    if (!parentResult || !parentResult.item || parentResult.hasFileProperty) {
      return null;
    }

    var items = [parentResult.item];
    var productTags = readProductTagsFromForm(form);
    var feeItems = buildFeeAttachmentItems(parentResult.parentVariantLegacyId, parentResult.parentQuantity, productTags);
    feeItems.forEach(function (item) { items.push(item); });

    var lubeItem = buildLubeAttachmentItem(
      form,
      parentResult.parentVariantLegacyId,
      parentResult.parentQuantity,
      parentResult.parentProperties,
    );
    if (lubeItem) {
      items.push(lubeItem);
    }

    var predictiveGiftItems = resolvePredictiveGiftItems(form, parentResult.parentQuantity);
    predictiveGiftItems.forEach(function (item) { items.push(item); });

    var upsellItems = buildUpsellAttachmentItems(
      form,
      formData,
      parentResult.parentVariantLegacyId,
      parentResult.parentQuantity,
    );
    upsellItems.forEach(function (item) { items.push(item); });

    var payload = {
      items: items,
    };
    if (sections.length) {
      payload.sections = sections;
      payload.sections_url = variantId ? rootPath + "variants/" + variantId : window.location.pathname;
    }

    return {
      payload: payload,
      hasAttachments: items.length > 1,
    };
  }

  async function requestCartAddJson(rootPath, payload) {
    var fetchInit = {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-QK-Fallback": "1",
      },
      body: JSON.stringify(payload || {}),
    };
    fetchInit[OUR_FETCH_MARKER] = true;
    enterOwnCartAdd("requestCartAddJson");
    var response;
    try {
      response = await fetch(rootPath + "cart/add.js", fetchInit);
    } finally {
      exitOwnCartAdd("requestCartAddJson");
    }
    var responseJson = await response.json().catch(function () { return {}; });
    return {
      response: response,
      responseJson: responseJson,
    };
  }

  function dispatchVariantAdded(form, responseJson) {
    var cartForVariantEvent = {
      sections: responseJson && responseJson.sections ? responseJson.sections : {},
    };

    form.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson && responseJson.hasOwnProperty("items") ? responseJson.items : [responseJson],
          cart: cartForVariantEvent,
        },
      }),
    );
  }

  function hydrateCartAndDispatchChange(rootPath, responseJson, baseEvent) {
    return fetch(rootPath + "cart.js", { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("cart.js fetch failed");
        return response.json();
      })
      .then(function (cartContent) {
        cartContent.sections = (responseJson && responseJson.sections) || safeObject(cartContent.sections);
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: { baseEvent: baseEvent, cart: cartContent },
          }),
        );
      });
  }

  /* ── AJAX cart/add ───────────────────────────────────────────── */

  async function submitWithAjax(form) {
    var atcToken = _setAtcInFlight("submitWithAjax");
    var rootPath = getRootPath();

    var sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    // Temporarily enable disabled variant inputs so FormData picks them up (Safari fix)
    var disabledInputs = form.querySelectorAll('input[name="id"][disabled], select[name="id"][disabled]');
    disabledInputs.forEach(function (el) { el.disabled = false; });
    var formData = new FormData(form);
    disabledInputs.forEach(function (el) { el.disabled = true; });

    var variantId = resolveVariantId(form);
    if (!formData.has("id") && variantId) formData.set("id", variantId);

    var packedContext = buildPackedAddPayload(form, formData, {
      rootPath: rootPath,
      variantId: variantId,
      sections: sectionsToBundle,
    });

    if (
      !packedContext ||
      !packedContext.hasAttachments ||
      !packedContext.payload ||
      !Array.isArray(packedContext.payload.items) ||
      !packedContext.payload.items.length
    ) {
      try {
        return await submitWithFormDataLegacy(form, formData, variantId, rootPath, sectionsToBundle);
      } finally {
        _clearAtcInFlight(atcToken, "submitWithAjax:legacy-return");
      }
    }

    try {
      var packedResult = await requestCartAddJson(rootPath, packedContext.payload);
      var response = packedResult.response;
      var responseJson = packedResult.responseJson;
      var usedParentOnlyFallback = false;

      if (!response.ok && response.status === 422 && packedContext.hasAttachments) {
        var parentOnlyPayload = {
          items: [packedContext.payload.items[0]],
        };
        if (Array.isArray(sectionsToBundle) && sectionsToBundle.length) {
          parentOnlyPayload.sections = sectionsToBundle;
          parentOnlyPayload.sections_url = packedContext.payload.sections_url || window.location.pathname;
        }

        var retryResult = await requestCartAddJson(rootPath, parentOnlyPayload);
        response = retryResult.response;
        responseJson = retryResult.responseJson;
        usedParentOnlyFallback = response.ok;
      }

      if (!response.ok) {
        form.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: { error: responseJson.description || CART_ERROR_MESSAGE },
          }),
        );
        return;
      }

      dispatchVariantAdded(form, responseJson);
      void hydrateCartAndDispatchChange(rootPath, responseJson, "qk:variant:add-packed").catch(function () {
        // Ignore hydration failures; native drawer updates from bundled sections.
      });

      if (usedParentOnlyFallback) {
        console.warn("[qk-product-form-fallback] packed add fallback: attachments skipped due to 422");
      }
    } finally {
      _clearAtcInFlight(atcToken, "submitWithAjax");
    }
  }

  async function submitWithFormDataLegacy(form, formData, variantId, rootPath, sectionsToBundle) {
    stripUpsellFormDataFields(formData);
    formData.set("sections", sectionsToBundle.join(","));
    if (variantId) formData.set("sections_url", rootPath + "variants/" + variantId);

    var fetchInit = {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-QK-Fallback": "1",
      },
    };
    fetchInit[OUR_FETCH_MARKER] = true;
    enterOwnCartAdd("submitWithFormDataLegacy");
    var response;
    try {
      response = await fetch(rootPath + "cart/add.js", fetchInit);
    } finally {
      exitOwnCartAdd("submitWithFormDataLegacy");
    }
    var responseJson = await response.json().catch(function () { return {}; });

    if (!response.ok) {
      form.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: responseJson.description || CART_ERROR_MESSAGE },
        }),
      );
      return;
    }

    var cartContent = await (await fetch(rootPath + "cart.js")).json();
    cartContent.sections = responseJson.sections;

    form.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson.items : [responseJson],
          cart: cartContent,
        },
      }),
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "variant:add", cart: cartContent },
      }),
    );
  }

  /* ── Submit handler ──────────────────────────────────────────── */

  async function onSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!shouldIntercept(event, form)) return;
    if (inflight.has(form) || isFormSubmitting(form)) {
      event.preventDefault();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();

    if (!form.checkValidity()) { form.reportValidity(); return; }

    var atcToken = _setAtcInFlight("submit-capture");
    inflight.add(form);
    markFormSubmitting(form);
    var buttons = getSubmitButtons(form);
    var startedAt = window.performance?.now?.() || Date.now();
    setButtonsBusy(buttons, true);
    debugLog("intercept submit", form.action, "hasVariantId", hasVariantIdValue(form));

    try {
      await submitWithAjax(form);
    } catch (err) {
      form.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: err?.message || CART_ERROR_MESSAGE },
        }),
      );
    } finally {
      var elapsed = (window.performance?.now?.() || Date.now()) - startedAt;
      if (elapsed < MIN_BUSY_MS) await new Promise(function (r) { setTimeout(r, MIN_BUSY_MS - elapsed); });
      setButtonsBusy(buttons, false);
      inflight.delete(form);
      clearFormSubmitting(form);
      _clearAtcInFlight(atcToken, "submit-capture");
    }
  }

  /* ── Safari polyfill: enable disabled variant inputs ─────────── */

  function enableDisabledVariantInputs() {
    Array.prototype.forEach.call(document.forms || [], function (form) {
      if (!isCartAddForm(form)) return;
      var input = form.querySelector('input[name="id"][disabled], select[name="id"][disabled]');
      if (input) input.disabled = false;
    });
  }

  /* ── Fetch interceptor for third-party ATC (TCustomizer, etc.) ── */

  /**
   * Apps like TCustomizer bypass form submission entirely — they call
   * fetch("/cart/add.js") directly. The theme's cart drawer needs
   * `variant:add` + `cart:change` events to open. This interceptor
   * watches for ANY successful POST to cart/add.js and dispatches those
   * events when our own submitWithAjax didn't initiate the request.
   */
  var OUR_FETCH_MARKER = "__qkFallbackFetch";

  function installFetchInterceptor() {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var requestObject = input instanceof Request ? input : null;
      var url = typeof input === "string" || input instanceof URL ? String(input) : (requestObject ? requestObject.url : "");
      var method = String((init && init.method) || (requestObject && requestObject.method) || "GET").toUpperCase();
      var isCartAdd = method === "POST" && isCartAddJsonUrl(url);
      var isOursMarker = Boolean(init && init[OUR_FETCH_MARKER]);
      var isOursDepth = ownCartAddDepth > 0;
      var isOurs = isOursMarker || isOursDepth;

      // If it's not a cart/add POST, or it's our own call, pass through.
      if (!isCartAdd || isOurs) {
        if (isCartAdd && isOurs) {
          debugLog("skip interceptor for own cart/add.js", "marker", isOursMarker, "depth", ownCartAddDepth);
        }
        return nativeFetch.apply(this, arguments);
      }

      var atcToken = _setAtcInFlight("fetch-interceptor:external-cart-add");
      debugLog("intercept external cart/add.js", url);

      // Third-party cart/add.js call — let it proceed, then dispatch events
      // from the cloned response while still returning the real response for
      // maximum compatibility with third-party callers.
      var realFetchPromise = nativeFetch.apply(this, arguments);
      var processingPromise = realFetchPromise.then(function (response) {
        if (!response.ok) return;

        return response.clone().json().then(function (responseJson) {
          // Don't interfere if the response looks wrong
          if (!responseJson || responseJson.status === 422) return;

          var rootPath = getRootPath();

          // Collect the section names the theme needs (e.g. "variant-added")
          var sectionsToBundle = ["variant-added"];
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:prepare-bundled-sections", {
              bubbles: true,
              detail: { sections: sectionsToBundle },
            }),
          );

          // Determine variant ID for Section Rendering API context
          var variantId = responseJson.hasOwnProperty("items")
            ? (responseJson.items[0] && responseJson.items[0].variant_id)
            : responseJson.variant_id;

          // Build parallel requests: cart.js + Section Rendering API
          var cartPromise = fetch(rootPath + "cart.js").then(function (r) { return r.json(); });
          var sectionsPromise = variantId
            ? fetch(rootPath + "variants/" + variantId + "?sections=" + sectionsToBundle.join(","))
                .then(function (r) { return r.json(); })
                .catch(function () { return null; })
            : Promise.resolve(null);

          return Promise.all([cartPromise, sectionsPromise]).then(function (results) {
            var cartContent = results[0];
            var sections = results[1];

            // Use sections from our Section Rendering API call, or fall back to
            // whatever the third-party response included, or empty object
            cartContent.sections = sections || responseJson.sections || {};

            // Find the closest cart form to use as event target
            var form = findAnyCartAddForm() || document.documentElement;

            form.dispatchEvent(
              new CustomEvent("variant:add", {
                bubbles: true,
                detail: {
                  items: responseJson.hasOwnProperty("items") ? responseJson.items : [responseJson],
                  cart: cartContent,
                },
              }),
            );

            document.documentElement.dispatchEvent(
              new CustomEvent("cart:change", {
                bubbles: true,
                detail: { baseEvent: "variant:add", cart: cartContent },
              }),
            );
          }).catch(function () { /* cart.js or sections fetch failed — silently ignore */ });
        }).catch(function () { /* JSON parse failed — not a standard Shopify response */ });
      }).catch(function () { /* network error — silently ignore */ }).finally(function () {
        _clearAtcInFlight(atcToken, "fetch-interceptor:external-cart-add");
      });

      // Fire-and-forget async event pipeline.
      processingPromise.catch(function () { /* swallow processing errors */ });

      // Compatibility-first: return the real response so third-party state
      // machines can settle and allow repeated ATC actions.
      return realFetchPromise;
    };
  }

  /* ── Init ────────────────────────────────────────────────────── */

  function init() {
    if (window[GLOBAL_LISTENER_KEY]) return;
    window[GLOBAL_LISTENER_KEY] = true;

    function onAtcPointerDownCapture(e) {
      var el = e.target instanceof Element ? e.target : null;
      if (!el) return;
      var btn = el.closest('button[type="submit"], button[name="add"], button[data-action="add-to-cart"], button[data-add-to-cart]');
      if (!(btn instanceof HTMLButtonElement)) return;
      if (isPaymentButton(btn)) return;
      var form = resolveAtcFormFromButton(btn);
      if (!form) return;

      // Block third-party pointer handlers that queue /cart redirects.
      e.stopImmediatePropagation();
    }

    function onAtcClickCapture(e) {
      var el = e.target instanceof Element ? e.target : null;
      if (!el) return;
      var btn = el.closest('button[type="submit"], button[name="add"], button[data-action="add-to-cart"], button[data-add-to-cart]');
      if (!(btn instanceof HTMLButtonElement)) return;
      if (isPaymentButton(btn)) return;
      var form = resolveAtcFormFromButton(btn);
      if (!form) return;
      if (inflight.has(form) || isFormSubmitting(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      _setAtcInFlight("click-capture");
      debugLog("intercept click", form.action, "hasVariantId", hasVariantIdValue(form));

      // Re-enable variant input in case it was disabled by third-party
      var variantInput = form.querySelector('input[name="id"][disabled], select[name="id"][disabled]');
      if (variantInput) variantInput.disabled = false;

      try {
        if (btn.type === "submit") {
          form.requestSubmit(btn);
        } else {
          form.requestSubmit();
        }
      } catch (_err) {
        // requestSubmit can throw TypeError if btn's form association is broken.
        // Fall back to dispatching submit event directly. SubmitEvent is not
        // available in all engines, so we guard and degrade to Event.
        var submitEvent;
        if (typeof SubmitEvent === "function") {
          submitEvent = new SubmitEvent("submit", { bubbles: true, cancelable: true, submitter: btn });
        } else {
          submitEvent = new Event("submit", { bubbles: true, cancelable: true });
          try {
            Object.defineProperty(submitEvent, "submitter", {
              configurable: true,
              get: function () { return btn; },
            });
          } catch (_defineError) {
            // ignore
          }
        }
        form.dispatchEvent(submitEvent);
      }
    }

    // Capture-phase click listener — intercepts ATC button clicks BEFORE
    // third-party apps (TCustomizer, etc.) can handle them and redirect to /cart.
    // Without this, apps call fetch("/cart/add.js") then window.location = "/cart",
    // navigating away before the cart drawer can open.
    window.addEventListener("pointerdown", onAtcPointerDownCapture, true);
    document.addEventListener("pointerdown", onAtcPointerDownCapture, true);
    window.addEventListener("click", onAtcClickCapture, true);
    document.addEventListener("click", onAtcClickCapture, true);

    // Single capture-phase submit listener.
    document.addEventListener("submit", function (e) { void onSubmit(e); }, true);
    document.addEventListener("variant:change", syncVariantPriceInputFromVariantChange, true);

    // Safety net: form.submit() bypasses the submit event entirely.
    // Patch it so any script calling form.submit() on a cart form routes through
    // requestSubmit(), which DOES fire our capture listener.
    var nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (!isCartAddForm(this) || !isSameOrigin(this.action)) return nativeSubmit.call(this);
      var active = document.activeElement;
      if (active instanceof Element && active.closest(".shopify-payment-button, .shopify-cleanslate")) {
        return nativeSubmit.call(this);
      }
      if (typeof this.requestSubmit === "function") {
        this.requestSubmit();
        return;
      }
      return nativeSubmit.call(this);
    };

    // Suppress forced cart-page navigations while ATC is in-flight.
    installLocationSuppressor();

    // Intercept third-party fetch() calls to cart/add.js so the cart
    // drawer always opens, even when apps bypass form submission.
    installFetchInterceptor();

    // Safari polyfill: customized built-in elements (<form is="product-form">)
    // don't work, so connectedCallback never enables the variant input.
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", enableDisabledVariantInputs);
    } else {
      enableDisabledVariantInputs();
    }

    // Also observe for dynamically-added forms (quick-buy drawers, etc.)
    if (typeof MutationObserver !== "undefined") {
      new MutationObserver(enableDisabledVariantInputs).observe(document.body || document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
  }

  init();
})();
